module.exports = __webpack_public_path__ + "img/JP-LOGO.9d88c97f.svg";